import { BriefingCard } from "./BriefingCard";
import { useBriefingData } from "./useBriefingData";

/**
 * Live Briefing Card — wires today's events, open tasks, and the watchlist into
 * the presentational BriefingCard. Mounted as the Synthesis "Briefing" tab.
 */
export function BriefingPanel({
  onEditWatchlist,
  onOpenEvent,
  showRefresh = true,
  showWatchlist = false,
  initialHorizon,
}: {
  onEditWatchlist?: () => void;
  /** Click an event → open it in the calendar. */
  onOpenEvent?: (id: string, start?: string | null) => void;
  /** Refresh button — off in the chat card. */
  showRefresh?: boolean;
  /** Watchlist section — separated out of the briefing by default (it lives in
   *  its own Watchlist surface), schedule + tasks only here. */
  showWatchlist?: boolean;
  /** Tab the card opens on (0=today, 10/30/90 days) — e.g. "next 90 days" asks. */
  initialHorizon?: 0 | 10 | 30 | 90;
}) {
  const { events, tasks, watchlist, now, toggleTask, refresh, isLoading, isError } = useBriefingData({
    includeWatchlist: showWatchlist,
  });

  if (isLoading) {
    return <div className="bc-loading">Pulling up your day…</div>;
  }

  return (
    <>
      {/* A failed feed would otherwise render as a confidently empty section
          ("nothing today") — say so and offer a retry instead (#5283). */}
      {isError && (
        <div className="bc-error" role="alert">
          <span>Couldn't load part of your briefing.</span>
          <button type="button" className="bc-error-retry" onClick={refresh}>
            Try again
          </button>
        </div>
      )}
      <BriefingCard
        events={events}
        tasks={tasks}
        watchlist={showWatchlist ? watchlist : []}
        now={now}
        onToggleTask={toggleTask}
        onOpenEvent={onOpenEvent}
        onEditWatchlist={showWatchlist ? onEditWatchlist : undefined}
        onRefresh={showRefresh ? refresh : undefined}
        initialHorizon={initialHorizon}
      />
    </>
  );
}

export default BriefingPanel;
